import { createStore, createTypedHooks, persist } from 'easy-peasy';
import { localeStore, LocaleStore } from './LocaleStore';
import { uiStore, UIStore } from './UIStrore';
import { userStore, UserStore } from './UserStore';

export interface StoreModel {
  locale: LocaleStore;
  ui: UIStore;
  user: UserStore;
}

const typedStore: StoreModel = {
  locale: localeStore,
  ui: uiStore,
  user: userStore,
};

const { useStoreActions, useStoreState, useStoreDispatch } = createTypedHooks<StoreModel>();

export { useStoreActions, useStoreDispatch, useStoreState };

const store = createStore(persist(typedStore));

export default store;
